import { PageInfo } from './page-info';
import { Order } from '../../../modules/shared/enums/order.enum';

/**
 * Adds extra sorting atributes to PageInfo object.
 */
export class SortedPageInfo extends PageInfo {
    sort: string[];
    order: Order[];

    constructor(page: number, itemsPerPage: number, sort: string[], order: Order[]) {
        super(page, itemsPerPage);
        this.sort = sort;
        this.order = order;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/model/pagination/sorted-page-info.ts